import React from 'react';

export function getDeployMode(role) {
  const IMMEDIATE_ROLES = ['ADMIN', 'HEAD_COACH', 'ANALYST_SCOUT'];
  if (IMMEDIATE_ROLES.includes(role)) return 'immediate';
  if (role === 'ASSISTANT_COACH') return 'schedule';
  return 'interview';
}

export default function AgentDeployFlow({ agent, onDeploy, onCancel }) {
  return (
    <div className="p-4 bg-[#111] rounded-xl border border-[#222]">
      <h3 className="text-white text-sm font-semibold mb-2">Deploy Agent</h3>
      <p className="text-[#888] text-xs">Agent deployment flow — coming soon</p>
      <div className="flex gap-2 mt-3">
        {onCancel && <button onClick={onCancel} className="text-xs text-[#888] hover:text-white">Cancel</button>}
        {onDeploy && <button onClick={onDeploy} className="text-xs text-[#E8B800]">Deploy</button>}
      </div>
    </div>
  );
}
